module.exports = __webpack_public_path__ + "img/FUE_footer_white.png";